import { useSplitTreatment } from './useSplitTreatment';
import {
  SPLIT_IO_FEATURE_FLAG_PDP_ENGAGING_IMAGES,
  SPLIT_IO_FEATURE_FLAG_PDP_ENGAGING_IMAGES_COOKIE
} from 'constants/split';
import { SPLIT_TRAFFIC_TYPES } from 'au-js-sdk/lib/services/split.io/constants';
import { useProduct } from '../../features/pdp';
import { DeviceSize, useWindowSize } from '../useWindowSize';

const PRODUCTS_IN_TEST = [
  'everyday-photo-book'
];

export const useShouldDisplayEngagingImages = (): boolean => {
  const { product } = useProduct();
  const { deviceSize } = useWindowSize();
  const isDesktop = deviceSize !== DeviceSize.SMALL;

  const { treatmentStatus: splitEnabled } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_PDP_ENGAGING_IMAGES,
    SPLIT_IO_FEATURE_FLAG_PDP_ENGAGING_IMAGES_COOKIE,
    SPLIT_TRAFFIC_TYPES.ANONYMOUS
  );

  const isRelevantProduct = PRODUCTS_IN_TEST.includes(product.sku);

  return splitEnabled && isDesktop && isRelevantProduct;
};
